"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUUID = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var generateUUID = function generateUUID() {
  if (typeof (0, _get2.default)(window, 'NWA.utils.generateUUID') === 'function') {
    // DEPRECATED
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('[DEPRECATED] Use nwa.generatePageViewId instead');
    }

    return window.NWA.utils.generateUUID();
  }

  return '';
};

exports.generateUUID = generateUUID;